import React, { useEffect, useState } from 'react';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import { Box, Button, IconButton, Modal, Pagination } from '@mui/material';
import Loader from '../common/Loader/Loader';
import { getReportsByUserId, updateReportStatus } from '../../api/report';
import SuspendCard from '../user-management/SuspendCard';
import CloseIcon from '@mui/icons-material/Close';
import ProfileCard from '../user-management/ProfileCard';
import { style2 } from '../user-management/UserList';
import { useNotification } from '../../hooks/useNotification';
import UserTableSkeleton from '../user-management/UserTableSkeleton';
import Tooltip from '@mui/material/Tooltip';
import { statusLabel } from '../../utils/memberStatus';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  width: '95%',
  margin: '0 auto',
  bgcolor: 'background.paper',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
  maxHeight: '80vh', // Adjust the height for scrolling
  overflow: 'auto', // Make content scrollable
};

function ReportListUser({ userId, type, isHideReportRequest = true, ClassName }) {
    const [data, setData] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState({
        reportedBy: true,
        reportedUser: true,
        reason: true,
        status: true,
        createdAt: true,
        reportedUserStatus: true,
        action: true
    });

    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 10;
    const [openSuspend, setOpenSuspend] = useState(false);
    const [openProfile, setOpenProfile] = React.useState(false);

    useEffect(() => {
        fetchReports();
    }, [userId, type, currentPage]);

    const fetchReports = async () => {
        setLoading(true);
        try {
            const response = await getReportsByUserId({ setData, userId, type, page: currentPage, groupBy: type });
            // setData(response.data);
            setTotalPages(response.totalPages);
        } catch (error) {
            console.error("Error fetching reports:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleColumnToggle = (column) => {
        setVisibleColumns((prev) => ({
            ...prev,
            [column]: !prev[column],
        }));
    };

    const filteredData = data
    // .filter((item) =>
    //     item?.reportedUser?.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item?.reportedBy?.userName?.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    const columnHeaders = [
        { key: 'reportedBy', label: 'Reported By' },
        { key: 'reportedUser', label: 'Reported User' },
        { key: 'reason', label: 'Reason' },
        { key: 'status', label: 'Status' },
        { key: 'reportedUserStatus', label: 'Reported User Status' },
        { key: 'createdAt', label: 'Reported At' },
    ];

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleOpenSuspend = () => {
        setOpenSuspend(true);
    };
    const handleCloseSuspend = () => setOpenSuspend(false);

    const handleOpenProfile = () => {
        setOpenProfile(true);
    };
    const handleCloseProfile = () => setOpenProfile(false);

    const { showErrorNotification, showSuccessNotification } = useNotification();


    const handleResolveReport = async (reportId) => {
        try {
            const updatedReport = await updateReportStatus({
                reportId,
                status: 'Resolved',
            });
            if (updatedReport) {
                showSuccessNotification('Report resolved successfully!');
                fetchReports()
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    return (
        <>
            <div className={`mb-0 d-flex justify-content-between align-items-center ${ClassName}`}>
                <h6 className="text-lg mb-0">Report Request</h6>

                <div className="d-flex align-items-center gap-2">
                    {/* <form className="navbar-search">
                        <input
                            type="text"
                            name="search"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </form> */}
                    {isHideReportRequest && (<Tooltip title="Download Data" placement="top" arrow>
                        <button className="badge text-sm fw-medium border bg-transparent px-10 py-10 radius-6 text-secondary-light">
                            <SimCardDownloadOutlinedIcon />
                        </button>
                    </Tooltip>)}
                    {/* {isHideReportRequest && (  <button className="badge text-sm fw-medium border border bg-transparent px-10 py-10 radius-6 text-secondary-light">
                        <FilterListOutlinedIcon />
                    </button> )} */}

                    {isHideReportRequest && (<div className="dropdown">
                        <Tooltip title="Manage Columns" arrow placement="top">
                            <button
                                className="badge text-sm fw-medium border bg-transparent px-10 py-10 radius-6 text-secondary-light"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <ViewColumnOutlinedIcon />
                            </button>
                        </Tooltip>
                        <ul className="dropdown-menu manage-list">
                            {columnHeaders.map((column) => (
                                <li key={column.key} className="dropdown-item d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input"
                                        style={{ width: '18px', height: '18px' }}
                                        type="checkbox"
                                        checked={visibleColumns[column.key]}
                                        onChange={() => handleColumnToggle(column.key)}
                                    />
                                    <label className="ms-2">{column.label}</label>
                                </li>
                            ))}
                        </ul>
                    </div>
                    )}
                </div>
            </div>

            <div className="table-responsive scroll-sm">
                <table className="table bordered-table sm-table mb-0">
                    <thead>
                        <tr style={{ background: '#f4f4f4', textAlign: 'left' }}>
                            <th>#</th>
                            {visibleColumns.reportedBy && <th>Reported By</th>}
                            {visibleColumns.reportedUser && <th>Reported User</th>}
                            {visibleColumns.reason && <th>Reason</th>}
                            {visibleColumns.status && <th>Status</th>}
                            {visibleColumns.reportedUserStatus && <th>Reported User Status</th>}
                            {visibleColumns.createdAt && <th>Reported At</th>}
                            {visibleColumns.action && <th>Action</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <UserTableSkeleton
                                rows={10}
                                columns={Object.keys(visibleColumns).filter((key) => visibleColumns[key]).length + 1}
                            />
                        ) : filteredData.length > 0 ? (
                            filteredData.map((item, index) => (
                                <tr key={index}>
                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    {visibleColumns.reportedBy && <td>{item?.reportedBy?.firstName ?? item?.reportedBy?.userName}</td>}
                                    {visibleColumns.reportedUser && <td>{item?.reportedUser?.firstName ?? item?.reportedUser?.userName}</td>}
                                    {visibleColumns.reason && <td>{item?.reason?.toLowerCase()==="other" ? item?.details : item?.reason }</td>}
                                    {visibleColumns.status && <td>{item.status}</td>}
                                    {visibleColumns.reportedUserStatus && (
                                        <td>
                                            {/* The server's canonical status; suspend-only is the fallback for an older server. */}
                                            {item?.reportedUser?.statusBucket
                                                ? statusLabel(item.reportedUser.statusBucket)
                                                : (item?.reportedUser?.suspend ? statusLabel('suspended') : '—')}
                                        </td>
                                    )}
                                    {visibleColumns.createdAt && <td>{new Date(item.createdAt).toLocaleString()}</td>}
                                    {visibleColumns.action && (
                                        <td className="text-center">
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-outline-primary-600 not-active px-18 py-6 dropdown-toggle toggle-icon text-sm"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    Action
                                                </button>
                                                <ul className="dropdown-menu" style={{}}>
                                                    <li>
                                                        <a
                                                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                            href="javascript:void(0)"
                                                            onClick={() => handleOpenProfile()}
                                                        >
                                                            View
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a
                                                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                            href="javascript:void(0)"
                                                            onClick={() => handleResolveReport(item._id)}
                                                        >
                                                            Resolve
                                                        </a>
                                                    </li>
                                                    {!item?.reportedUser?.suspend && (
                                                        <li>
                                                            <a
                                                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                                                href="javascript:void(0)"
                                                                onClick={() => handleOpenSuspend()}
                                                            >
                                                                Suspend
                                                            </a>
                                                        </li>
                                                    )}

                                                </ul>
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="20" className="text-center py-3">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="d-flex justify-content-center mt-16">
                <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    sx={{
    "& .MuiPaginationItem-root": {
      color: "#000",  
      border: "1px solid #ddd",
    },

    "& .Mui-selected": {
      backgroundColor: "#ff4a4a !important",  
      color: "#fff",
    },

    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "#ffe5e5",
    },
  }} 
                />
            </div>

            <Modal
                open={openSuspend}
                onClose={handleCloseSuspend}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <IconButton
                        sx={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                        }}
                        onClick={handleCloseSuspend}
                    >
                        <CloseIcon />
                    </IconButton>
                    <SuspendCard
                        userId={userId}
                        handleClose={handleCloseSuspend}
                        fetchData={fetchReports}
                    />
                </Box>
            </Modal>

            {/* <div>
                <Button
                    className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                    onClick={() => handleOpenSuspend()}
                >
                    Suspend User
                </Button>
            </div> */}

            <Modal
                open={openProfile}
                onClose={handleCloseProfile}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style2}>
                    <Box
                        sx={{
                            position: 'sticky',
                            top: '0px',
                            backgroundColor: 'white',
                            zIndex: 10,
                            padding: '10px',
                            borderBottom: 'none',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <IconButton
                            sx={{
                                position: 'absolute',
                                top: 10,
                                right: 0,
                            }}
                            onClick={handleCloseProfile}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <ProfileCard userId={userId} />
                </Box>
            </Modal>
        </>
    );
}

export default ReportListUser;
